import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph } from 'ViatoUi/Shared/Typo';

const Footer = () => {
	const { t } = useTranslation('contractGenerator');

	return (
		<Paragraph color='silver' font='normal' centered>
			{t('app.taxInfo')}
		</Paragraph>
	);
};

export default Footer;
